export interface OtherContractFilter {
  filterType?: string[];
  fromDate?: Date;
  toDate?: Date;
  isUpdated?: boolean;
}

export const getDefaultOtherContractFilter = (): OtherContractFilter => {
  const today = new Date();
  const oneMonthAgo = new Date(new Date().setMonth(today.getMonth() - 1));

  return {
    filterType: ['CREATED'],
    fromDate: oneMonthAgo,
    toDate: today,
    isUpdated: false
  };
};
